import React from "react";
import "./style.css";
function RRBStateFiltersUi({
    selectData,
    filtersId,
    applyFilter,
    removeFilter,
    decodedToken,
    showFilter,
    isFilter,
    setIsFilter,
    setFiltersId
}) {
    const handleRemoveFilter = (key) => {
        setFiltersId({ ...filtersId, [key]: "" }); // Clear the filter value
        applyFilter();
        setIsFilter(true);
        removeFilter(); // Call the remove filter method
    };
    const getLabelFromId = (key, id) => {
        if (key === "rrbId" && id) {
            const rrbData = selectData?.rrb?.find((val) => val?.id == id);
            return rrbData ? `${rrbData?.name}` : id;
        }
        if (key === "stateId" && id) {
            const stateData = selectData?.states?.find((val) => val?.id == id);
            return stateData ? `${stateData?.name}` : id;
        }
        return id; // Fallback for unhandled cases
    };
    const renderAppliedFilters = () => {
        const appliedFilters = Object.entries(filtersId).filter(
            ([key, value]) => value !== "" && value !== undefined
        );

        return appliedFilters?.map(([key, value]) => (
            <div>
                <button
                    type="button"
                    className="btn btn-secondary rounded-5 px-2 ml-2 h-30px f-12px"
                    onClick={() => handleRemoveFilter(key)}
                >
                    {getLabelFromId(key, value)} <i className="fa fa-times f-12px"></i>
                </button>
            </div>
        ));
    };
    return (
        <div>
            <div className="ranodom-select-css-filter">
                <div className="d-flex align-items-center w-100">
                    <div class="form-group mb-0 d-flex align-items-center">
                        {showFilter?.rrb && (decodedToken?.role == 3 || decodedToken?.role == 4) && (
                            <div>
                                <div class="form-group mb-0">
                                    <select
                                        id="rrb_id"
                                        name="rrb_id"
                                        className="form-control w-100 p-2 select_css select2bs4"
                                        style={{ minWidth: '200px' }}
                                        value={filtersId?.rrbId}
                                    >
                                        <option value="">Select RRB</option>
                                        {selectData?.rrb?.map((val) => {
                                            const id = val?.id;
                                            return (
                                                <option value={id}>{val.name}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        )}

                        {showFilter?.state && (decodedToken?.role == 3 || decodedToken?.role == 4) && (
                            <div className="ml-3">
                                <div class="form-group mb-0">
                                    <select
                                        id="state_id"
                                        name="state_id"
                                        value={filtersId?.stateId}
                                        className="form-control w-100 p-2 select_css select2bs4"
                                        style={{ minWidth: '200px' }}
                                    >
                                        <option value="">Select State</option>
                                        {selectData?.states?.map((val) => {
                                            const id = val?.id;
                                            return (
                                                <option value={id}>{val.name}</option>
                                            );
                                        })}
                                    </select>
                                </div>
                            </div>
                        )}
                        {(
                            decodedToken?.role == 3 || decodedToken?.role == 4
                        ) && (
                                <button className="common_filters_clear_btn mx-3"
                                    onClick={() => {
                                        removeFilter();
                                        setIsFilter(false);
                                    }}
                                >
                                    Clear
                                </button>
                            )
                        }

                    </div>
                </div>
            </div>
        </div>
    );
}

export default RRBStateFiltersUi;
